import { DeliveryChannel } from '@pushly/models/lib/enums/delivery-channels.enum'
import { Platform } from '@pushly/cuttlefish'

export const DeliveryChannelPlatforms: Record<DeliveryChannel, Platform[]> = {
    [DeliveryChannel.WEB]: [Platform.ANDROID, Platform.WINDOWS, Platform.MAC_OS],
    [DeliveryChannel.NATIVE_ANDROID]: [Platform.NATIVE_ANDROID],
    [DeliveryChannel.NATIVE_IOS]: [Platform.IOS],
}
